import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import DailyReportsServices from "../../services/axiosServices/apiServices/DailyReportsServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { getAuthProps } from "../../utils/AuthenticationLibrary";

ModuleRegistry.registerModules([AllCommunityModule]);

class MinMaxStockRegisterLevel extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            colDefs: [
                {
                    headerName: "Drawing no", field: "drawingNo",
                    width: Math.max(window.innerWidth * 0.1, 50), filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Search text", field: "searchText",
                    width: Math.max(window.innerWidth * 0.1, 50), filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Item category", field: "itemCategory",
                    width: Math.max(window.innerWidth * 0.09, 50), filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Item name", field: "itemName",
                    width: Math.max(window.innerWidth * 0.15, 50), filter: true,
                    floatingFilter: true,
                    pinned: "left"
                },
                {
                    headerName: "Minimum stock", field: "minimumStock",
                    minWidth: window.innerWidth * 0.06,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Store", field: "store",
                    minWidth: window.innerWidth * 0.03,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "PI qty", field: "piQty",
                    minWidth: window.innerWidth * 0.03,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "PO qty", field: "poQty",
                    minWidth: window.innerWidth * 0.03,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Work planning qty", field: "workPlanningQty",
                    minWidth: window.innerWidth * 0.08,
                    flex: 1, filter: true,
                    floatingFilter: true,
                },
            ],
            rowData: [
                // {
                //     drawing_no: "DRW-001",
                //     search_text: "Part A",
                //     item_category: "Category 1",
                //     item_name: "Item Alpha",
                //     minimum_stock: 100,
                //     store: "Main Store",
                //     pi_qty: 50,
                //     po_qty: 75,
                //     work_planning_qty: 25,
                // },                
            ],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
        };
        this.gridApi = null;
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.procItemStockRegister_ForMinimumStockLevel();
            });
        } else {
            //window.location.href = "/Login";
        }
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);
        window.addEventListener("resize", this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    procItemStockRegister_ForMinimumStockLevel = () => {
        let idCompany = this.state.idCompany;
        //debugger;
        this.dailyReportsServices.procItemStockRegister_ForMinimumStockLevel(idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let data = response.responseItem.responseContent;
                this.setState({ rowData: data }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                    }
                    //let data = this.state.userDetails;
                    //data.databaseName = databasename;
                    //this.setState({ rowData: data })
                    //this.goToNextStep()
                });
            }
        });
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    render() {
        return (
            <div className='stock-adjustment'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className="table w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[79vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Min/max stock register level</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData} // Pass row data
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs} // Pass column definitions
                                    pagination={true} // Enable pagination
                                    paginationPageSize={this.state.paginationPageSize}
                                    rowSelection={this.rowSelection}
                                    onGridReady={this.onGridReady} // Capture API reference
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'} // Custom loading text
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default MinMaxStockRegisterLevel;